import React from 'react';
import './ContactPage.css';

const contacts = [
  { name: 'Krishna Ravindranath', phone: '+1 832-691-9247' },
  { name: 'Banashri', phone: '+1 980-248-8370' },
  { name: 'Kamalesh Bhattacharya', phone: '+1 704-449-5609' },
  { name: 'Sekhar Naskar', phone: '+1 704-236-0224' },
];

export default function ContactPage() {
  return (
    <div className="contact-page">
      <div className="contact-panel">
        <header className="contact-header">
          <p className="contact-eyebrow">Vedanta Center of Charlotte</p>
          <h1>We would be glad to hear from you</h1>
          <p className="contact-intro">
            Connect with the center online or reach out directly to one of our local contacts.
          </p>
        </header>

        <div className="contact-channels">
          <a
            className="contact-channel"
            href="https://www.facebook.com/groups/1150517765574184"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="contact-channel-icon" aria-hidden="true">
              <i className="fa-brands fa-facebook-f" />
            </span>
            <span>
              <strong>Join us on Facebook</strong>
              <small>Vedanta Center Charlotte</small>
            </span>
            <i className="fa-solid fa-arrow-up-right-from-square contact-channel-arrow" aria-hidden="true" />
          </a>
          <a className="contact-channel" href="mailto:info@vedantacentercharlotte.org">
            <span className="contact-channel-icon" aria-hidden="true">
              <i className="fa-solid fa-envelope" />
            </span>
            <span>
              <strong>Email the center</strong>
              <small>info@vedantacentercharlotte.org</small>
            </span>
            <i className="fa-solid fa-arrow-right contact-channel-arrow" aria-hidden="true" />
          </a>
        </div>

        <section className="contact-directory" aria-labelledby="contact-directory-heading">
          <div className="contact-section-heading">
            <p className="contact-eyebrow">Local connections</p>
            <h2 id="contact-directory-heading">Reach out to our center contacts</h2>
          </div>

          <div className="contact-table-wrap">
            <table className="contact-table">
              <thead>
                <tr>
                  <th scope="col">Name</th>
                  <th scope="col">Phone</th>
                </tr>
              </thead>
              <tbody>
                {contacts.map((person) => (
                  <tr key={person.name}>
                    <td data-label="Name">{person.name}</td>
                    <td data-label="Phone">
                      <a href={`tel:${person.phone.replace(/[^\d+]/g, '')}`}>
                        <i className="fa-solid fa-phone" aria-hidden="true" />
                        {person.phone}
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      </div>
    </div>
  );
}
